import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DeploymentInfoService } from '../services/deployment-info/deployment-info.service';

/**
 * Admits a route only when platform scripting is enabled on the deployment
 * (deployment-info `scripting.enabled`). Otherwise redirects to the project the
 * route belongs to, or to the project list, so a bookmarked Dappa URL on a
 * deployment without scripting lands somewhere useful instead of a page whose
 * every request would 404.
 */
export const scriptingEnabledGuard: CanActivateFn = async (route) => {
  const deploymentInfo = inject(DeploymentInfoService);
  const router = inject(Router);

  try {
    // Idempotent: normally already loaded during app init.
    await deploymentInfo.load();
  } catch {
    // Treated as "scripting off" below.
  }

  if (deploymentInfo.scriptingEnabled()) {
    return true;
  }
  const projectId = route.paramMap.get('projectId');
  return projectId ? router.createUrlTree(['/project', projectId]) : router.createUrlTree(['/projects']);
};
